export default __webpack_public_path__ + "static/surprised-69451c850df5e6aa3e460d3acb30f18f.png";